import { render } from "./Signup.vue?vue&type=template&id=73cb7805&scoped=true"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"

import "./Signup.vue?vue&type=style&index=0&id=73cb7805&scoped=true&lang=css"

import exportComponent from "/home/rosenfeldt/projects/rosenfeldt/public_html/webshop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73cb7805"]])

export default __exports__